import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hotel-result-shimmer',
  templateUrl: './hotel-result-shimmer.component.html',
  styleUrls: ['./hotel-result-shimmer.component.scss']
})
export class HotelResultShimmerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
